import { createAction, handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
import { createRecommendDefaultSchedule } from '../../../util/campaignScheduleUtil';

// action types
const SET_MOSU_CNT_INIT = 'recommend/SET_MOSU_CNT_INIT';

const SET_MOSU_CNT = 'recommend/SET_MOSU_CNT';
const SET_MOSU_QUERY = 'recommend/SET_MOSU_QUERY';
const SET_MOSU_DESC = 'recommend/SET_MOSU_DESC';
const SET_MOSU_JSON = 'recommend/SET_MOSU_JSON';

const SET_TARGET_TYPE = 'recommend/SET_TARGET_TYPE';
const SET_MAPTICS_SEND_TYPE = 'recommend/SET_MAPTICS_SEND_TYPE';
const SET_COLL_START_DAY = 'recommend/SET_COLL_START_DAY';
const SET_COLL_END_DAY = 'recommend/SET_COLL_END_DAY';
const SET_COLL_SND_DAY = 'recommend/SET_COLL_SND_DAY';
const SET_RT_END_HOUR = 'recommend/SET_RT_END_HOUR';
const SET_RT_END_MINUTE = 'recommend/SET_RT_END_MINUTE';
const SET_SCHEDULE = 'recommend/SET_SCHEDULE';
const SET_MAPTICS_DATA = 'recommend/SET_MAPTICS_DATA';
const SET_MAPTICS_TARGET_ID = 'recommend/SET_MAPTICS_TARGET_ID';

const SET_COUPON_LIST = 'recommend/SET_COUPON_LIST';
const SET_SELECTED_COUPON = 'recommend/SET_SELECTED_COUPON';
const SET_CASH_AMOUNT = 'recommend/SET_CASH_AMOUNT';
const SET_FREE_AMOUNT = 'recommend/SET_FREE_AMOUNT';
const SET_TXT_MESSAGE_UNIT = 'recommend/SET_TXT_MESSAGE_UNIT';
const SET_IMG_MESSAGE_UNIT = 'recommend/SET_IMG_MESSAGE_UNIT';

const SET_GROUPED_MESSAGES_TYPE = 'recommend/SET_GROUPED_MESSAGES_TYPE';
const SET_GROUPED_MESSGES_TYPE_LIST = 'recommend/SET_GROUPED_MESSGES_TYPE_LIST';
const SET_GROUPED_BASE_MESSAGES_TYPE = 'recommend/SET_GROUPED_BASE_MESSAGES_TYPE';
const SET_GROUPED_BASE_MESSGES_TYPE_LIST = 'recommend/SET_GROUPED_BASE_MESSGES_TYPE_LIST';
const SET_GROUPED_MESSAGES = 'recommend/SET_GROUPED_MESSAGES';
const SET_PAGE = 'recommend/SET_PAGE';
const SET_TOTAL = 'recommend/SET_TOTAL';

const SET_MESSAGE_DETAIL = 'recommend/SET_MESSAGE_DETAIL';

const SET_AGE_FROM = 'recomment/SET_AGE_FROM';
const SET_AGE_TO = 'recomment/SET_AGE_TO';
const SET_SEND_NUMBER = 'recomment/SET_SEND_NUMBER';
const SET_SEND_DATE = 'recomment/SET_SEND_DATE';
const SET_SEND_TYPE = 'recomment/SET_SEND_TYPE';

const INIT_VARIABLE_MAP = 'recommend/INIT_VARIABLE_MAP';
const SET_VARIABLE_MAP = 'recommend/SET_VARIABLE_MAP';
const INIT_URL_MAP = 'recommend/INIT_URL_MAP';
const SET_URL_MAP = 'recommend/SET_URL_MAP';

const SET_BUTTON_COUNT = 'recommend/SET_BUTTON_COUNT';
const SET_BUTTON_INFO = 'recommend/SET_BUTTON_INFO';
const SET_BUTTON_COORDINATE = 'recommend/SET_BUTTON_COORDINATE';

const SET_CREATED_CAMPAIGN_UID = 'recommend/SET_CREATED_CAMPAIGN_UID';

const SET_BILLING_TYPE = 'recommend/SET_BILLING_TYPE';
const SET_RCS_TYPE = 'recommend/SET_RCS_TYPE';
const SET_MESSAGE_TYPE = 'recommend/SET_MESSAGE_TYPE';
const SET_RCS_TYPE_FIELD = 'recommend/SET_RCS_TYPE_FIELD';

const SET_RCSFILE = 'recommend/SET_RCSFILE';
const SET_MMSFILE = 'recommend/SET_MMSFILE';
const SET_IMG_NAME = 'recommend/SET_IMG_NAME';
const SET_PREVIEW = 'recommend/SET_PREVIEW';
const SET_RCS_INFO_IMG_ORIG_ID = 'recommend/SET_RCS_INFO_IMG_ORIG_ID';
const SET_MMS_FILE_ORIG_ID = 'recommend/SET_MMS_FILE_ORIG_ID';

export const setRCSFile = createAction(SET_RCSFILE, (index, value) => ({ index, value }));
export const setMMSFile = createAction(SET_MMSFILE);
export const setImgName = createAction(SET_IMG_NAME);
export const setPreview = createAction(SET_PREVIEW);
export const setRcsInfoImgOrigId = createAction(SET_RCS_INFO_IMG_ORIG_ID, (value, index)=>({ value, index }));
export const setMmsFileOrigId = createAction(SET_MMS_FILE_ORIG_ID, (value, index)=>({ value, index }));

export const setMessageType = createAction(SET_MESSAGE_TYPE);
export const setRcsType = createAction(SET_RCS_TYPE_FIELD);
export const setrcsType = createAction(SET_RCS_TYPE);

export const setBillingType = createAction(SET_BILLING_TYPE);

// action creators
export const setMosuCntInit = createAction(SET_MOSU_CNT_INIT);
export const setMosuCnt = createAction(SET_MOSU_CNT);
export const setMosuQuery = createAction(SET_MOSU_QUERY);
export const setMosuDesc = createAction(SET_MOSU_DESC);
export const setMosuJson = createAction(SET_MOSU_JSON);

export const setTargetType = createAction(SET_TARGET_TYPE);
export const setMapticsSendType = createAction(SET_MAPTICS_SEND_TYPE);
export const setCollStartDate = createAction(SET_COLL_START_DAY);
export const setCollEndDate = createAction(SET_COLL_END_DAY);
export const setCollSndDate = createAction(SET_COLL_SND_DAY);
export const setRtEndHour = createAction(SET_RT_END_HOUR);
export const setRtEndMinute = createAction(SET_RT_END_MINUTE);
export const setSchedule = createAction(SET_SCHEDULE);
export const setMapticsData = createAction(SET_MAPTICS_DATA);
export const setMapticsTargetId = createAction(SET_MAPTICS_TARGET_ID);

export const setCouponList = createAction(SET_COUPON_LIST);
export const setSelectedCoupon = createAction(SET_SELECTED_COUPON);
export const setCashAmount = createAction(SET_CASH_AMOUNT);
export const setFreeAmount = createAction(SET_FREE_AMOUNT);
export const setTxtMessageUnit = createAction(SET_TXT_MESSAGE_UNIT);
export const setImgMessageUnit = createAction(SET_IMG_MESSAGE_UNIT);

export const setGroupedMessages = createAction(SET_GROUPED_MESSAGES);
export const setGMType = createAction(SET_GROUPED_MESSAGES_TYPE);
export const setGMTypeList = createAction(SET_GROUPED_MESSGES_TYPE_LIST)
export const setBGMType = createAction(SET_GROUPED_BASE_MESSAGES_TYPE);
export const setBGMTypeList = createAction(SET_GROUPED_BASE_MESSGES_TYPE_LIST)
export const setPage = createAction(SET_PAGE);
export const setTotal = createAction(SET_TOTAL);

export const setMessageDetail = createAction(SET_MESSAGE_DETAIL);
export const setAgeFrom = createAction(SET_AGE_FROM);
export const setAgeTo = createAction(SET_AGE_TO);
export const setSendNumber = createAction(SET_SEND_NUMBER);
export const setSendDate = createAction(SET_SEND_DATE);
export const setSendType = createAction(SET_SEND_TYPE);

export const initVariableMap = createAction(INIT_VARIABLE_MAP)
export const setVariableMap = createAction(SET_VARIABLE_MAP);
export const initUrlMap = createAction(INIT_URL_MAP);
export const setUrlMap = createAction(SET_URL_MAP);

export const setButtonCount = createAction(SET_BUTTON_COUNT);
export const setButtonInfo = createAction(SET_BUTTON_INFO);
export const setButtonCoordinate = createAction(SET_BUTTON_COORDINATE)

export const setCreatedCampaignUid = createAction(SET_CREATED_CAMPAIGN_UID);

const defaultSchedule = createRecommendDefaultSchedule();

// initial state
const initialState = Map( {
    mosuCntInit: 0,

    mosuCnt: 0,
    mosuQuery: '',
    mosuDesc: '',
    mosuJson: '',

    targetType: defaultSchedule.targetType,
    mapticsSendType: defaultSchedule.mapticsSendType,
    collStartDate: defaultSchedule.collStartDate,
    collEndDate: defaultSchedule.collEndDate,
    collSndDate: defaultSchedule.collSndDate,
    rtEndHour: defaultSchedule.rtEndHour,
    rtEndMinute: defaultSchedule.rtEndMinute,
    mapticsData: {
        address: '',
        gender: '0',
        minAge: 0,
        maxAge: 0,
        radius: 0,
        stayMin: 0,
    },
    mapticsTargetId: 0,


    couponList: [],
    selectedCoupon: {},
    cashAmount: 0,
    freeAmount: 0,
    txtMessageUnit: 120,
    imgMessageUnit: 140,

    groupedMessages: [],
    gmType: {'uid':12},
    gmTypeList: [],
    bgmType: '',
    bgmTypeList: [],
    page:1,
    total: 0,
    size: 3,

    messageDetail: {
        uid: 0,
        name: '',
        rcsTitle: '',
        rcsMessage: '',
        callback: '',
        sndNum: '',
    },
    ageFrom: 20,
    ageTo: 50,
    sendNumber: 1000,
    sendDate: defaultSchedule.sendDate,

    sendType: 'ALL',

    variableMap: {},
    urlMap: {},

    buttonCount: [],
    buttonInfo: [],

    createdCampaignUid: 0,

    rcsType: 51,
    RCSType: '이미지',
    billingType: 1,

    rcsImgOrigId: '',
    mmsImgOrigId: '',
    messageType: '일반 문자메시지-이미지',

    RCSFile: [null],
    MMSFile: null,
    imgName: '',
})

// reducer
export default handleActions({
    [SET_MOSU_CNT_INIT]: (state, action) => {
        const mosuCntInit = action.payload;
        return state.set('mosuCntInit', mosuCntInit);
    },
    [SET_MOSU_CNT]: (state, action) => {
        const mosuCnt = action.payload;
        return state.set('mosuCnt', mosuCnt);
    },
    [SET_MOSU_QUERY]: (state, action) => {
        const mosuQuery = action.payload;
        return state.set('mosuQuery', mosuQuery);
    },
    [SET_MOSU_DESC]: (state, action) => {
        const mosuDesc = action.payload;
        return state.set('mosuDesc', mosuDesc);
    },
    [SET_MOSU_JSON]: (state, action) => {
        const mosuJson = action.payload;
        return state.set('mosuJson', mosuJson);
    },

    [SET_TARGET_TYPE]: (state, action) => {
        const targetType = action.payload;
        return state.set('targetType', targetType);
    },
    [SET_MAPTICS_SEND_TYPE]: (state, action) => {
        const mapticsSendType = action.payload;
        return state.set('mapticsSendType', mapticsSendType);
    },
    [SET_COLL_START_DAY]: (state, action) => {
        const collStartDate = action.payload;
        return state.set('collStartDate', collStartDate);
    },
    [SET_COLL_END_DAY]: (state, action) => {
        const collEndDate = action.payload;
        return state.set('collEndDate', collEndDate);
    },
    [SET_COLL_SND_DAY]: (state, action) => {
        const collSndDate = action.payload;
        return state.set('collSndDate', collSndDate);
    },
    [SET_RT_END_HOUR]: (state, action) => {
        const rtEndHour = action.payload;
        return state.set('rtEndHour', rtEndHour);
    },
    [SET_RT_END_MINUTE]: (state, action) => {
        const rtEndMinute = action.payload;
        return state.set('rtEndMinute', rtEndMinute);
    },
    [SET_SCHEDULE]: (state, action) => state.merge(action.payload),
    [SET_MAPTICS_DATA]: (state, action) => {
        const mapticsData = action.payload;
        return state.set('mapticsData', mapticsData);
    },
    [SET_MAPTICS_TARGET_ID]: (state, action) => {
        const mapticsTargetId = action.payload;
        return state.set('mapticsTargetId', mapticsTargetId);
    },

    [SET_COUPON_LIST]: (state, action) => {
        const couponList = action.payload;
        return state.set('couponList', couponList);
    },
    [SET_SELECTED_COUPON]: (state, action) => {
        const selectedCoupon = action.payload;
        return state.set('selectedCoupon', selectedCoupon);
    },
    [SET_CASH_AMOUNT]: (state, action) => {
        const cashAmount = action.payload;
        return state.set('cashAmount', cashAmount);
    },
    [SET_FREE_AMOUNT]: (state, action) => {
        const freeAmount = action.payload;
        return state.set('freeAmount', freeAmount);
    },
    [SET_TXT_MESSAGE_UNIT]: (state, action) => {
        const txtMessageUnit = action.payload;
        return state.set('txtMessageUnit', txtMessageUnit);
    },
    [SET_IMG_MESSAGE_UNIT]: (state, action) => {
        const imgMessageUnit = action.payload;
        return state.set('imgMessageUnit', imgMessageUnit);
    },

    [SET_GROUPED_MESSAGES_TYPE]: (state, action) => {
        const gmType = action.payload;
        return state.set('gmType', gmType);
    },
    [SET_GROUPED_MESSGES_TYPE_LIST] : (state, action) => {
        const gmTypeList = action.payload;
        return state.set('gmTypeList', gmTypeList);
    },
    [SET_GROUPED_BASE_MESSAGES_TYPE]: (state, action) => {
        const bgmType = action.payload;
        return state.set('bgmType', bgmType);
    },
    [SET_GROUPED_BASE_MESSGES_TYPE_LIST] : (state, action) => {
        const bgmTypeList = action.payload;
        return state.set('bgmTypeList', bgmTypeList);
    },
    [SET_GROUPED_MESSAGES]: (state, action) => {
        const groupedMessages = action.payload;
        return state.set('groupedMessages', groupedMessages);
    },
    [SET_PAGE]: (state, action) => {
        const page = action.payload;
        return state.set('page', page);
    },
    [SET_TOTAL]: (state, action) => {
        const total = action.payload;
        return state.set('total', total)
    },

    [SET_MESSAGE_DETAIL]: (state, action) => {
        const messageDetail = action.payload;
        return state.set('messageDetail', messageDetail);
    },
    [SET_AGE_FROM]: (state, action) => {
        const ageFrom = action.payload;
        return state.set('ageFrom', ageFrom);
    },
    [SET_AGE_TO]: (state, action) => {
        const ageTo = action.payload;
        return state.set('ageTo', ageTo);
    },
    [SET_SEND_NUMBER]: (state, action) => {
        const sendNumber = action.payload;
        return state.set('sendNumber', sendNumber);
    },
    [SET_SEND_DATE]: (state, action) => {
        const sendDate = action.payload;
        return state.set('sendDate', sendDate);
    },
    [SET_SEND_TYPE]: (state, action) => {
        const sendType = action.payload;
        return state.set('sendType', sendType);
    },

    [INIT_VARIABLE_MAP]: (state, action) => {
        const variableMap = action.payload;
        return state.set('variableMap', variableMap);
    },
    [SET_VARIABLE_MAP]: (state, action) => {
        const keyValue = action.payload;
        return state.setIn(['variableMap', keyValue.key], keyValue.value);
    },
    [INIT_URL_MAP]: (state, action) => {
        const urlMap = action.payload;
        return state.set('urlMap', urlMap);
    },
    [SET_URL_MAP]: (state, action) => {
        const keyValue = action.payload;
        return state.setIn(['urlMap', keyValue.key], keyValue.value);
    },

    [SET_BUTTON_COUNT]: (state, action) => {
        const buttonCount = action.payload;
        return state.set('buttonCount', buttonCount);
    },
    [SET_BUTTON_INFO]: (state, action) => {
        const buttonInfo = action.payload;
        return state.set('buttonInfo', buttonInfo);
    },
    [SET_BUTTON_COORDINATE]: (state, action) => {
        const buttonCoordinate = action.payload;

        if (buttonCoordinate.key === 'type') {
            let val1 = buttonCoordinate.value === 'WEB' ? 'https://' : '';
            let val2 = buttonCoordinate.value === 'MAP' ? 'https://' : '';

            state = state
                .setIn(['buttonInfo', buttonCoordinate.index, 'name'], '')
                .setIn(['buttonInfo', buttonCoordinate.index, 'val1'], val1)
                .setIn(['buttonInfo', buttonCoordinate.index, 'val2'], val2);
        }

        return state.setIn(['buttonInfo', buttonCoordinate.index, buttonCoordinate.key], buttonCoordinate.value);
    },

    [SET_RCSFILE]: (state, action) => {
        const { index, value } = action.payload;

        // Immutable.Map에서 값 꺼내기
        const currentFiles = state.get('RCSFile') || [];

        // 새로운 배열 생성
        const newFiles = currentFiles.map((info, i) =>
            i === index ? value : info
        );

        // Immutable.Map에 다시 set
        return state.set('RCSFile', newFiles);
    },
    [SET_MMSFILE]: (state, action) => {
        return state.set('MMSFile', action.payload);
    },

    [SET_IMG_NAME]: (state, action) => {
        return state.set('imgName', action.payload);
    },

    [SET_RCS_INFO_IMG_ORIG_ID]: (state, action) => {
        return state.set('rcsImgOrigId', action.payload);
    },

    [SET_MMS_FILE_ORIG_ID]: (state, action) => {
        return state.set('mmsImgOrigId', action.payload);
    },

    [SET_BILLING_TYPE]: (state, action) => {
        return state.set('billingType', action.payload);
    },
    [SET_RCS_TYPE]: (state, action) => {
        return state.set('rcsType', action.payload);
    },
    [SET_MESSAGE_TYPE]: (state, action) => {
        return state.set('messageType', action.payload);
    },
    [SET_RCS_TYPE_FIELD]: (state, action) => {
        return state.set('RCSType', action.payload);
    },


    [SET_CREATED_CAMPAIGN_UID]: (state, action) => {
        const createdCampaignUid = action.payload;
        return state.set('createdCampaignUid', createdCampaignUid);
    },
}, initialState)
